import * as motion from "motion/react-client";
import {Sparkles, X, User, Divide, Plus, Minus, Undo2, GalleryHorizontalEnd} from "lucide-react";
import {Card, CardContent} from "../../ui/Card";
import { useNavigate } from "react-router-dom";

const MathStart = () => {
    const navigate = useNavigate()
    const goToOperation = (operation: string) => {
        navigate(`/math/${operation}`)
    }
    return (
        <div className={"flex flex-col gap-3"}>
            <div className="flex w-full" style={{ justifyContent: "center" }}>
                <motion.button className="text-lg px-4 py-2 w-1/3 grid grid-cols-2 bg-blue-500 hover:bg-orange-500 rounded-xl"
                               onClick={() => navigate("/home")}>
                    <Undo2 />Back
                </motion.button>
            </div>

            {/* Hero Section */}
            <main className="flex flex-col items-center justify-center text-center p-8">
                <motion.div className="flex flex-row justify-center items-center gap-4 text-nowrap">
                    <GalleryHorizontalEnd size={"3.25em"} />
                    <motion.h2
                        className="text-5xl font-extrabold mx-auto my-0"
                        initial={{ opacity: 0, y: -40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        Flash Cards
                    </motion.h2>
                </motion.div>
            </main>

            {/* Cards Section */}
            <section className="grid grid-cols-1 md:grid-cols-1 gap-6 p-4 w-full max-w-6xl text-center">
                <motion.p
                    className="text-lg max-w-2xl"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                >
                    Select an operation to begin practice!
                </motion.p>
                <section className="grid grid-cols-2 md:grid-cols-2 justify-center gap-4 py-6 px-6 w-full max-w-3xl">
                    {[
                        { operation: "multiplication", color: "bg-pink-400", icon: <Plus size={"10dvh"}/>, goTo: "addition" },
                        { operation: "multiplication", color: "bg-green-400", icon: <Minus size={"10dvh"}/>, goTo: "subtraction" },
                        { operation: "multiplication", color: "bg-orange-400", icon: <X size={"10dvh"}/>, goTo: "multiplication" },
                        { operation: "multiplication", color: "bg-blue-400", icon: <Divide size={"10dvh"}/>, goTo: "division" },
                    ].map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2 }}
                        >
                            <Card className={`rounded shadow-lg hover:scale-105 transition-transform duration-300 ${item.color}`}
                                  onClick={() => goToOperation(item.goTo)}>
                                <CardContent className="flex flex-col items-center justify-center h-28 text-white">
                                    {item.icon}
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </section>
            </section>
            {/*<section className="grid grid-cols-2 md:grid-cols-2 justify-center gap-4 py-6 px-6 w-full max-w-3xl">*/}
            {/*    {[*/}
            {/*        { operation: "multiplication", color: "bg-pink-400", icon: <Plus size={"10dvh"}/>, goTo: "addition" },*/}
            {/*        { operation: "multiplication", color: "bg-green-400", icon: <Minus size={"10dvh"}/>, goTo: "subtraction" },*/}
            {/*        { operation: "multiplication", color: "bg-orange-400", icon: <X size={"10dvh"}/>, goTo: "multiplication" },*/}
            {/*        { operation: "multiplication", color: "bg-blue-400", icon: <Divide size={"10dvh"}/>, goTo: "division" },*/}
            {/*    ].map((item, index) => (*/}
            {/*        <motion.div*/}
            {/*            key={index}*/}
            {/*            initial={{ opacity: 0, y: 30 }}*/}
            {/*            animate={{ opacity: 1, y: 0 }}*/}
            {/*            transition={{ delay: index * 0.2 }}*/}
            {/*        >*/}
            {/*            <Card className={`rounded shadow-lg hover:scale-105 transition-transform duration-300 ${item.color}`}*/}
            {/*            onClick={() => goToOperation(item.goTo)}>*/}
            {/*                <CardContent className="flex flex-col items-center justify-center h-28 text-white">*/}
            {/*                    {item.icon}*/}
            {/*                </CardContent>*/}
            {/*            </Card>*/}
            {/*        </motion.div>*/}
            {/*    ))}*/}
            {/*</section>*/}
        </div>);
}

export default MathStart;